import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const ProcessWorkstation = ({ workstation, isActive, onActivate }) => {
  const [hoveredElement, setHoveredElement] = useState(null);

  const handleElementClick = (element) => {
    if (element?.type === 'interactive') {
      // Simulate interaction
      console.log(`Interacting with ${element?.name}`);
    }
  };

  return (
    <div 
      className={`relative bg-card rounded-xl border transition-all duration-500 cursor-pointer ${
        isActive 
          ? 'border-accent shadow-lg cosmic-glow scale-105' 
          : 'border-border hover:border-accent/50 hover:shadow-md'
      }`}
      onClick={onActivate}
    >
      {/* Workstation Header */}
      <div className="p-6 border-b border-border/20">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center transition-colors ${
              isActive ? 'bg-accent text-background' : 'bg-surface text-accent'
            }`}>
              <Icon name={workstation?.icon} size={24} />
            </div>
            <div>
              <h3 className="font-headline font-bold text-xl text-foreground">
                {workstation?.name}
              </h3>
              <p className="font-body text-sm text-muted-foreground">
                {workstation?.description}
              </p>
            </div>
          </div>
          <div className={`px-3 py-1 rounded-full text-xs font-medium ${
            isActive 
              ? 'bg-accent/20 text-accent' :'bg-surface text-muted-foreground'
          }`}>
            {workstation?.phase}
          </div>
        </div>
      </div>
      {/* Interactive Elements */}
      <div className="p-6">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {workstation?.elements?.map((element, index) => (
            <div
              key={index}
              className={`relative p-4 rounded-lg border cursor-pointer transition-all duration-300 ${
                hoveredElement === index
                  ? 'border-accent bg-accent/10 scale-105' :'border-border/30 bg-surface/30 hover:border-accent/50'
              }`}
              onMouseEnter={() => setHoveredElement(index)}
              onMouseLeave={() => setHoveredElement(null)}
              onClick={() => handleElementClick(element)}
            >
              <div className="flex items-center space-x-3 mb-2">
                <Icon 
                  name={element?.icon} 
                  size={16} 
                  className={hoveredElement === index ? 'text-accent' : 'text-muted-foreground'} 
                />
                <span className="font-body font-medium text-sm text-foreground">
                  {element?.name}
                </span>
              </div>
              
              {element?.type === 'interactive' && (
                <div className="text-xs text-muted-foreground">
                  Click to explore
                </div>
              )}

              {element?.type === 'visualization' && (
                <div className="mt-2 h-8 bg-gradient-to-r from-accent/20 to-cosmic-energy/20 rounded"></div>
              )}

              {hoveredElement === index && element?.tooltip && (
                <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 -translate-y-full z-10">
                  <div className="bg-popover text-popover-foreground px-3 py-2 rounded-lg text-xs font-body shadow-lg border border-border/20">
                    {element?.tooltip}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-popover"></div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Tools & Techniques */}
        <div className="mt-6 pt-6 border-t border-border/20">
          <h4 className="font-body font-semibold text-sm text-foreground mb-3">
            Tools & Techniques
          </h4>
          <div className="flex flex-wrap gap-2">
            {workstation?.tools?.map((tool, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-surface/50 text-muted-foreground text-xs rounded-full font-body"
              >
                {tool}
              </span>
            ))}
          </div>
        </div>

        {/* Metrics */}
        {workstation?.metrics && (
          <div className="mt-4 grid grid-cols-2 gap-4">
            {workstation?.metrics?.map((metric, index) => (
              <div key={index} className="text-center">
                <div className="font-headline font-bold text-lg text-accent">
                  {metric?.value}
                </div>
                <div className="font-body text-xs text-muted-foreground">
                  {metric?.label}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Active State Indicator */}
      {isActive && (
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent rounded-full flex items-center justify-center">
          <Icon name="Zap" size={14} className="text-background" />
        </div>
      )}
    </div>
  );
};

export default ProcessWorkstation;